export default [
  {
    path: '/reports',
    name: 'dashboard-reports',
    component: () => import('@/views/dashboard/reports/Reports.vue'),
  },
]
